<template>
  <ol class="ranking-list">
    <li class="ranking-list__item head-item">
      <div class="rank flex-all-center">
        {{ Ranking.text.overall[lang] }}
      </div>
      <div class="company flex-all-center">
        {{ Ranking.text.company[lang] }}
      </div>
      <template v-for="(ranking_item, index) in dataEventSummary.ranking_items">
        <div class="head flex-all-center" :key="index">
          {{ Ranking.text[ranking_item][lang] }}
        </div>
      </template>
      <div class="complete flex-all-center">
        {{ Ranking.text.certificate[lang] }}
      </div>
    </li>
    <li
      v-for="(content, rankingIndex) in dataRanking.team_ranking
        .company_contents"
      :key="rankingIndex"
      class="ranking-list__item detail-item"
    >
      <div v-if="content.rank === 1" class="rank">
        <img src="../../../../assets/images/ranking/1st-place.svg" alt="" />
      </div>
      <div v-else-if="content.rank === 2" class="rank">
        <img src="../../../../assets/images/ranking/2nd-place.svg" alt="" />
      </div>
      <div v-else-if="content.rank === 3" class="rank">
        <img src="../../../../assets/images/ranking/3rd-place.svg" alt="" />
      </div>
      <div v-else class="rank">{{ content.rank }}</div>
      <div class="company">{{ content.company_name }}</div>
      <template v-for="(ranking_item, index) of dataEventSummary.ranking_items">
        <div
          class="runner-num"
          v-if="ranking_item === Ranking.id.runner_num"
          :key="index"
          >{{ content.runner_num }}</div
        >
        <div
          class="time"
          v-if="ranking_item === Ranking.id.time"
          :key="index"
          >{{ dataRanking.converted_time[rankingIndex] }}</div
        >
        <div
          class="distance"
          v-if="ranking_item === Ranking.id.distance"
          :key="index"
          >{{ dataRanking.converted_distance[rankingIndex] }}</div
        >
        <div
          class="completed-num"
          v-if="ranking_item === Ranking.id.completed_num"
          :key="index"
          >{{ content.completed_num }}</div
        >
      </template>
      <div class="complete">
        <!-- 確定時 && (完走者1以上 || 規定距離なし) : 完走証へのリンク -->
        <router-link
          :to="{
            path: `/${langPath}${
              $route.path.includes('company') ? 'company/' : ''
            }ranking/certificate`,
            query: {
              event: nassEventId,
              team: content.company_id,
            },
          }"
          class="certificate confirm"
          v-if="
            eventStatus === '100' &&
            ((content.completed_num &&
              'true' === content.is_over_required_finishers_number) ||
              (!dataEventSummary.summary.has_regulated_distance &&
                content.distance > 0))
          "
        >
          {{ Ranking.text.certificate[lang] }}
        </router-link>
      </div>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    lang: String,
    langPath: String,
    Ranking: Object,
    dataEventRanking: Object,
    dataEventSummary: Object,
    dataRanking: Object,
    eventStatus: String,
    isForeignCountry: Boolean,
    nassEventId: String,
  },
  name: "TeamRankingList",
};
</script>

<style scoped lang="scss">
.ranking-list {
  margin: 40px 0 0 0;

  .rank,
  .head,
  .runner-num,
  .time,
  .distance,
  .completed-num,
  .complete,
  .company {
    margin: 0 18px 0 0;
  }

  .rank,
  .head,
  .runner-num,
  .time,
  .distance,
  .completed-num {
    width: 100px;
    word-wrap: break-word;
  }

  .complete {
    width: 120px;
  }

  .company {
    flex: 1;
    word-break: break-word;
  }

  .ranking-list__item {
    margin: 0 -18px 0 0;
    display: flex;
    text-align: center;
  }

  .head-item {
    font-size: 18px;
    font-weight: bold;

    .rank,
    .head,
    .runner-num,
    .time,
    .distance,
    .completed-num,
    .complete,
    .company {
      padding: 0 0 12px 0;
      border-bottom: solid 3px #000;
    }
  }

  .detail-item {
    padding: 25px 0;
    min-height: 120px;
    align-items: center;
    border-bottom: solid 1px #999;

    .rank {
      font-size: 30px;
      font-weight: bold;
    }

    .company {
      padding: 0 0 0 10px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
    }

    .head,
    .runner-num,
    .time,
    .distance,
    .completed-num {
      font-size: 20px;
    }

    .complete {
      font-size: 20px;
      font-weight: bold;
    }

    .certificate {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 70px;
      border: solid 1px #000;
      background-color: #fff;
      font-size: 14px;
      font-weight: normal;

      &::before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 16px;
        margin: 0 0 4px 0;
        background: url("../../../../assets/images/certificate/certificate.svg")
          no-repeat center / 12px 16px;
      }
    }

    .confirm {
      &:hover {
        color: #fff;
        background-color: #000;

        &::before {
          background: url("../../../../assets/images/certificate/certificate-hover.svg")
            no-repeat center / 12px 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/company/ranking/TeamRankingList.vue